const events = {
  // use when you want to add clickable areas to the popover, that you do not want it to destroy
  dismissOnOffClick: {
    data: () => {
      return {
        additionalTargets: new Set()
      }
    },
    methods: {
      handleDocumentClick (e) {
        let contiansArea = this.$el.contains(e.target)
        for (const target of this.additionalTargets) {
          contiansArea |= target.contains(e.target)
        }
        if (!contiansArea) {
          this.dismiss()
        }
      },
      addClickableArea (target) {
        this.additionalTargets.add(target)
      },
      removeClickableArea (removeTarget) {
        this.additionalTargets.delete(removeTarget)
      }
    },
    mounted: function () {
      window.addEventListener('mousedown', this.handleDocumentClick, true)
    },
    beforeDestroy: function () {
      window.removeEventListener('mousedown', this.handleDocumentClick, true)
    }
  },
  dismissOnClickTimer: function (miliseconds) {
    let createdDate = new Date(Date.now() + miliseconds)
    return {
      methods: {
        handleDismissOnClickTimer (e) {
          let newDate = new Date()
          let passTime = newDate > createdDate
          if (passTime && !this.$el.contains(e.target)) {
            this.dismiss()
          }
        }
      },
      mounted: function () {
        window.addEventListener('mousedown', this.handleDismissOnClickTimer, true)
      },
      beforeDestroy: function () {
        window.removeEventListener('mousedown', this.handleDismissOnClickTimer, true)
      }
    }
  },
  handleScroll: {
    methods: {
      handleScroll (e) {
        if (!this.$el.contains(e.target)) {
          this.dismiss()
        }
      }
    },
    mounted: function () {
      window.addEventListener('scroll', this.handleScroll, true)
    },
    beforeDestroy: function () {
      window.removeEventListener('scroll', this.handleScroll, true)
    }
  },
  dismiss: {
    data () {
      return {
        hasDismissed: false
      }
    },
    methods: {
      dismiss () {
        let timeForAnimations = 125
        if (this && this.$el) {
          // TOOD this need to happen after, the select on does...
          this.$emit('dismiss')
          this.hasDismissed = true
          this.$destroy()
          setTimeout(() => {
            if (this && this.$el) {
              this.$el.parentNode.removeChild(this.$el)
            }
          }, timeForAnimations)
        }
      }
    },
    mounted: function () {
      window.addEventListener('hashchange', this.dismiss, true)
    },
    beforeDestroy: function () {
      window.removeEventListener('hashchange', this.dismiss, true)
    }
  },
  hoverOver: function (el, areaIncludeHoverOver) {
    // defaults to true
    areaIncludeHoverOver = !(areaIncludeHoverOver === false)
    return {
      methods: {
        handleHover (e) {
          let inActivationArea = el && el.contains(e.target)
          let thePopover = this.$el.contains(e.target)
          let inArea = (inActivationArea || (areaIncludeHoverOver && thePopover))
          if (!inArea) {
            this.dismiss()
          }
        }
      },
      mounted: function () {
        window.addEventListener('mousemove', this.handleHover, true)
      },
      beforeDestroy: function () {
        window.removeEventListener('mousemove', this.handleHover, true)
      }
    }
  },
  dismissAfterXSecondsHover: function (el, areaIncludeHoverOver) {
    // defaults to true
    areaIncludeHoverOver = !(areaIncludeHoverOver === false)
    return {
      data: () => {
        return {
          millisecondsToAllow__dismissAfterXSeconds: 2 * 1000, // we want it in seconds though
          lastTime_dismissAfterXSeconds: null,
          BUFFER_dismissAfterXSeconds: 50, // this is the buffer for latency issues,
          outsideArea_dismissAfterXSeconds: true  // is the current pointer outside the box of the popover
        }
      },
      methods: {
        handleHover__DismissAfterXSeconds (e) {
          let inActivationArea = el && el.contains(e.target)
          let thePopover = this.$el.contains(e.target)
          let inArea = (inActivationArea || (areaIncludeHoverOver && thePopover))
          if (inArea) {
            this.setDismissAfterXTime()
            this.setOutsideArea_dismissAfterXSeconds(false)
          } else {
            this.setOutsideArea_dismissAfterXSeconds(true)
          }
        },
        setDismissAfterXTime () {
          this.lastTime_dismissAfterXSeconds = new Date().getTime()
        },
        activateTheDismissPeriod () {
          setTimeout(() => {
            if (this.outsideArea_dismissAfterXSeconds) {
              if (this.pastTimeOut_dismissAfterXSeconds()) {
                this.dismiss()
              }
            }
            if (!this.hasDismissed) {
              this.activateTheDismissPeriod()
            }
          },
            this.millisecondsSinceLastHover_dismissAfterXSeconds())
        },
        pastTimeOut_dismissAfterXSeconds () {
          return (new Date().getTime() - this.lastTime_dismissAfterXSeconds) >= this.millisecondsToAllow__dismissAfterXSeconds - this.BUFFER_dismissAfterXSeconds
        },
        millisecondsSinceLastHover_dismissAfterXSeconds () {
          if (this.outsideArea_dismissAfterXSeconds) {
            return this.lastTime_dismissAfterXSeconds - new Date().getTime() + this.millisecondsToAllow__dismissAfterXSeconds
          } else {
            return this.millisecondsToAllow__dismissAfterXSeconds
          }
        },
        setOutsideArea_dismissAfterXSeconds (val) {
          this.outsideArea_dismissAfterXSeconds = val
        }
      },
      mounted: function () {
        window.addEventListener('mousemove', this.handleHover__DismissAfterXSeconds, true)
        this.setDismissAfterXTime()
        this.activateTheDismissPeriod()
      },
      beforeDestroy: function () {
        window.removeEventListener('mousemove', this.handleHover__DismissAfterXSeconds, true)
      }
    }
  }
}

export default events



// WEBPACK FOOTER //
// ./src/app/components/common/popover/builderComponents/events.js